/*
 * Copyright (c) 2011 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.coloring.implementation

import org.mkui.color.MkColor
import org.mkui.coloring.MutableColoring

/**
 * A simple mutable coloring implementation.
 */
class SimpleColoring<E> : AbstractColoring<E>(), MutableColoring<E> {
    private val coloring: MutableMap<E, MkColor>

    override val coloredCount: Int
        get() = coloring.size


    override fun isColored(element: E): Boolean {
        return coloring.containsKey(element)
    }

    override fun getColor(element: E): MkColor? {
        return coloring[element]
    }

    override operator fun iterator(): Iterator<E> {
        return coloring.keys.iterator()
    }

    override fun clearColoring() {
        val changes: MutableSet<E> = HashSet()
        for (e in this) {
            changes.add(e)
        }
        coloring.clear()
        notifyColoringChanged(SimpleColoringEvent(changes))
    }

    override fun setColor(element: E, color: MkColor?) {
        if (color != null) {
            val changes: MutableSet<E> = HashSet()
            changes.add(element)
            coloring[element] = color
            notifyColoringChanged(SimpleColoringEvent(changes))
        } else {
            if (isColored(element)) {
                val changes: MutableSet<E> = HashSet()
                changes.add(element)
                coloring.remove(element)
                notifyColoringChanged(SimpleColoringEvent(changes))
            }
        }
    }

    override fun setColorElements(elements: Iterable<E>, color: MkColor?) {
        if (color != null) {
            val changes: MutableSet<E> = HashSet()
            for (element in elements) {
                changes.add(element)
                coloring[element] = color
            }
            if (changes.size > 0) {
                notifyColoringChanged(SimpleColoringEvent(changes))
            }
        } else {
            val changes: MutableSet<E> = HashSet()
            for (element in elements) {
                if (isColored(element)) {
                    changes.add(element)
                    coloring.remove(element)
                }
            }
            if (changes.size > 0) {
                notifyColoringChanged(SimpleColoringEvent(changes))
            }
        }
    }

    init {
        coloring = HashMap()
    }
}